<template>
  <div>
    <link rel="stylesheet" href="/css/products-4.css" />
    <section class="breadcrumb_nav">
      <div class="breadcrumb_nav_img relative">
        <img src="https://slzx-chengc.oss-cn-shenzhen.aliyuncs.com/sljt-ueeShop/articles/image_1668499027_21.jpg" alt="img" />
        <h2 class="breadcrumb_nav_title text-center hidden-xs">{{ $t("products.banneTitle") }}</h2>
      </div>

      <div class="breadcrumb_nav_wrap">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="breadcrumb_nav_box">
                <ul class="breadcrumb_nav_list">
                  <li>
                    <a href="/">{{ $t("products.navTxt1") }}</a>
                  </li>

                  <li>
                    <i class="fa fa-angle-double-right"></i>
                    <span> {{ $t("products.navTxt2") }}</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <main class="ny-products-list">
      <section class="pagination-section">
        <div class="container">
          <div class="list-description content-style pt-4 p-3 border">
            <h3 style="font-size: 22px">{{ $t("products.listTtile") }}</h3>
            <div v-html="$t('products.listContent')"></div>
          </div>
        </div>
      </section>

      <div class="section-margin-1x"></div>
      <section class="products-list">
        <div class="container">
          <div class="row">
            <div class="col-lg-9">
              <div class="section-main">
                <p v-if="loading" class="text-muted" style="text-align: center">{{ $t("account.loading") }}...</p>
                <div class="mb-4" @click="toDetail(item)" v-for="(item, index) in list" :key="index">
                  <div class="thumbnail">
                    <div class="row">
                      <div class="col-sm-5">
                        <a class="thumbnail-img"><img :src="item.cover" width="100%" height="330" /></a>
                      </div>
                      <div class="col-sm-7">
                        <h3 class="thumbnail-title">
                          <a> {{ item.productName }} </a>
                        </h3>
                        <div class="content-style clamp clamp4" style="margin-bottom: 25px" v-html="item.productDescribe"></div>
                        <div class="button-box row">
                          <!-- <a
                            data-fancybox
                            data-src="#QuickInquiryModal"
                            hrefs="javascript:;"
                            class="btn btn-secondary col QuickInquiryModalBtn"
                            >{{ $t('products.itemBtn1') }}</a
                          > -->
                          <a class="btn btn-primary col">{{ $t("products.itemBtn2") }}</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <p v-if="!list.length && !loading" class="text-muted" style="text-align: center">{{ $t("account.empty") }}</p>
                <nav v-if="total > page.per_page" aria-label="Page navigation" style="text-align: right; margin-top: 30px">
                  <ul class="pagination">
                    <li :class="{ disabled: page.page === 1 }" key="a">
                      <a href="javascript:;" aria-label="Previous" @click="page.page !== 1 && page.page++">
                        <span aria-hidden="true">&laquo;</span>
                      </a>
                    </li>
                    <li v-for="(item, i) in Math.ceil(total / page.per_page)" :key="i" :class="{ active: page.page === item }">
                      <a href="javascript:;" @click="page.page = item">{{ item }}</a>
                    </li>
                    <li :class="{ disabled: page.page === Math.ceil(total / page.per_page) }" key="b">
                      <a href="javascript:;" aria-label="Next" @click="page.page !== Math.ceil(total / page.per_page) && page.page++">
                        <span aria-hidden="true">&raquo;</span>
                      </a>
                    </li>
                  </ul>
                </nav>
              </div>

              <!-- <div class="pagination-section text-center">
                <ul class="pagination">
                  <li :class="{'active':info.page == 1}" @click="pageClick(1)"><a hrefs="javascript:void(0);">1</a></li>
              
                </ul>
              </div> -->
            </div>
            <div class="col-lg-3 visible-lg">
              <aside>
                <!-- 侧边搜索-->
                <div class="aside-search">
                  <div>
                    <div class="input-group">
                      <input type="search" name="keyword" v-model="productName" class="form-control" :placeholder="$t('products.serachTxt')" />
                      <span class="input-group-btn">
                        <button class="btn btn-default btn-primary" @click="()=>{page.page=1;getList()}" type="submit">{{ $t("products.rightBtn") }} →</button>
                      </span>
                    </div>
                  </div>
                </div>
                <!-- /侧边搜索 -->

                <div class="mb-3"></div>

                <!-- 侧边导航菜单 -->

                <div class="aside-munu">
                  <ul id="asideMenu" class="list-group">
                    <li class="list-group-item tree-empty" v-for="(item, index) in [$t('products.rightListItem1'), $t('products.rightListItem2'), $t('products.rightListItem3'), $t('products.rightListItem4')]" :key="index">
                      <span class="toggler"></span>
                      <a @click="productType = index + 1">{{ item }} </a>
                    </li>
                  </ul>
                </div>
                <!-- /侧边导航菜单 -->

                <div class="mb-3"></div>
              </aside>
              <div class="section-margin-2x"></div>
            </div>
          </div>
        </div>
      </section>

      <!-- <div class="section-margin-1x">
        <div class="container">
          <hr />
        </div>
      </div> -->
      <!-- <section class="recommend-section">
        <div class="container">
          <div class="section-head">
            <h2>{{ $t("products.botTxt") }}</h2>
          </div>
        </div>
        <div class="container">
          <div id="RecommendProducts" class="owl-carousel owl-theme recommend-carousel">
            <div v-for="(item, index) in recommendProducts" @click.stop="toDetail(item)" class="thumbnail recommend-thumbnail">
              <div class="row">
                <div class="col-sm-6">
                  <a><img :src="item.cover" width="100%" /></a>
                </div>
                <div class="col-sm-6" style="padding: 0">
                  <h3>
                    <a>{{ item.productName }}</a>
                  </h3>
                  <div class="recommend-desc" v-html="item.productDescribe"></div>
                  <div class="button-box row">
                    <a data-fancybox data-src="#QuickInquiryModal" href="javascript:;" class="btn btn-secondary col QuickInquiryModalBtn">{{ $t("products.itemBtn1") }} →</a>
                    <a class="btn btn-primary col">{{ $t("products.itemBtn2") }} →</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> -->
      <div class="section-margin-2x"></div>
    </main>
  </div>
</template>

<script setup>
import { onMounted, watch, ref } from "vue"
import i18n from "@/i18n"
import router from "@/router/index"
import { reactive } from "vue"
import { pageIndependentProduct } from "@/utils/api"

const list = ref([])
const recommendProducts = ref([])
const total = ref(0)
const productType = ref()
const productName = ref("")
const loading = ref(true)
const page = reactive({ page: 1, per_page: 10 })

const getList = () => {
  loading.value = true
  list.value = []
  pageIndependentProduct({ page, productType: productType.value, productName: productName.value, language: i18n.locale, state: 0 }).then((res) => {
    loading.value = false
    list.value = res.data.list
    total.value = res.data.total
  })
}

const getRecommendProducts = () => {
  pageIndependentProduct({ page: { page: 1, per_page: 5 }, language: i18n.locale, state: 0 }).then((res) => {
    recommendProducts.value = res.data.list
    $(function () {
      setTimeout(() => {
        if ($("#RecommendProducts").length) {
          $("#RecommendProducts").owlCarousel({
            margin: 10,
            items: 1,
            loop: true,
            nav: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            rtl: document.querySelector("html").getAttribute("dir") === "rtl",
            dots: true,
            autoplay: true,
            autoplayTimeout: 4000,
            autoplayHoverPause: true,
            lazyLoad: true,
            responsive: {
              480: {
                items: 1
              },
              768: {
                items: 2
              },
              1024: {
                items: 2
              }
            }
          })
        }
      }, 500)
    })
  })
}

getList()

watch([page, productType], () => {
  getList()
})

watch(
  () => i18n.locale,
  (currentValue, prevValue) => {
    getList()
    getRecommendProducts()
  }
)

let toDetail = (item) => {
  router.push({
    path: "/ProductDetail",

    query: {
      id: item.id,
      productId: item.productId
    }
  })
}

onMounted(() => {
  getRecommendProducts()
})
</script>

<style scoped>
main.ny-products-list {
  margin-top: 70px;
}
main .content-style {
  font-size: 16px;
}
main .content-style h3 {
  border-left: 0.12em solid var(--main-theme-color) !important;
}
main .products-list .thumbnail-img {
  height: 240px;
  overflow: hidden;
  display: block;
  border: 1px solid #eee;
  position: relative;
}
main .products-list .thumbnail-img img {
  border: none;
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
}
main .thumbnail .thumbnail-title {
  height: auto;
}
main .thumbnail-title a {
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 22px;
  line-height: 26px;
  display: block;
}
main .aside-product .media .media-heading {
  font-size: 16px;
  font-weight: 500;
  line-height: 22px;
  display: block;
}
main .section-head h2 {
  margin-top: 0;
  font-size: 25px;
  margin-bottom: 1.2em;
}
main .section-head h2:after {
  background-color: var(--main-theme-color);
}
main .aside-munu .list-group-item.active > a,
main .aside-munu .list-group-item.tree-opened > a {
  color: var(--main-theme-color) !important;
}
main .thumbnail .button-box.row .btn {
  padding: 0.5em 10px;
  width: auto;
  font-size: 14px;
}
main .recommend-thumbnail h3 {
  height: auto;
}
main .recommend-thumbnail h3 a {
  font-size: 18px;
  line-height: 22px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  height: 44px;
}
main .recommend-desc {
  font-size: 16px;
  margin: 1.2em 0 2.5em;
  height: 66px;
  line-height: 22px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
[dir="rtl"] main .content-style h3 {
  border-right: 0.12em solid var(--main-theme-color) !important;
  border-left: 0 !important;
  padding-left: 0;
  padding-right: 0.5em;
}
[dir="rtl"] main .aside-munu .list-group-item a {
  padding-right: 3em;
  padding-left: 0;
}
[dir="rtl"] main .section-head h2:after {
  left: auto;
  right: 0;
}

@media only screen and (max-width: 991px) {
  main.ny-products-list {
    margin-top: 60px;
  }
  main .section-margin-2x {
    margin: 50px;
  }
}
@media only screen and (max-width: 767px) {
  main.ny-products-list {
    margin-top: 50px;
  }
  main .section-margin-2x {
    margin: 45px;
  }
  main .section-margin-1x {
    margin: 10px;
  }
  main .thumbnail-title a {
    font-size: 20px;
  }
  main .section-head h2 {
    font-size: 21px;
  }
}
</style>
